import classNames from 'classnames';
import type { FC } from 'react';
import { Link } from 'wouter';

import { Button } from '@atlas/components';

import pushToDataLayer, { btag } from 'utils/dataLayer';
import useLayout from 'utils/layout';
import { Translation } from 'utils/translations';

import styles from './CasinoGames.module.scss';
import Games from './Games';

type CasinoGamesProps = {
  title: string;
  actionButton: string;
};

const CasinoGames: FC<CasinoGamesProps> = ({ title, actionButton }) => {
  const layout = useLayout();

  return (
    <div className={classNames(styles.wrapper, styles[layout])}>
      <p className={classNames(styles.title, styles[layout])}>
        <Translation message={title} />
      </p>
      <Games />
      <Link
        to="/casino"
        onClick={() => pushToDataLayer('main_all_games_button_click', btag)}
        className={styles['action-button']}
      >
        <Button>
          <Translation message={actionButton} />
        </Button>
      </Link>
    </div>
  );
};

export default CasinoGames;
